export default __webpack_public_path__ + "static/media/Offline.d5a017c1.svg";